import QualityWarning from './QualityWarning'

export default QualityWarning